import { makeStyles, Theme } from "@material-ui/core/styles";

import { Product } from "../../../types";

type DynamicStylesProps = Partial<Product>;
const useStyles = makeStyles((theme: Theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalView: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: 345,
    height: 610,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 18,
  },
  close: {
    position: "absolute",
    top: 15,
    right: 15,
    width: 24,
    height: 24,
    zIndex: 20,
  },
  contentContainer: {
    flex: 1,
    width: "100%",
    overflowY: "auto",
    paddingTop: 65,
    paddingBottom: 20,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  buttonContainer: {
    position: "sticky",
    bottom: 0,
    width: "100%",
    padding: "16px",
    zIndex: 15,
    borderRadius: 18,
  },
  info: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    "& span": {
      fontSize: 18,
    },
  },
  image: {
    width: 200,
    height: 200,
    borderRadius: 32,
    marginBottom: 10,
    backgroundImage: ({ picture }: DynamicStylesProps) => `url(${picture})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundClip: "border-box",
    boxShadow:
      "0px 8px 12px rgba(0, 0, 0, 0.08), 0px 4px 48px rgba(0, 0, 0, 0.08)",
  },
  observation: {
    marginBottom: 30,
  },
  orderView: {
    width: 200,
  },
  amount: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    height: 46,
    paddingLeft: 10,
    paddingRight: 10,
    borderRadius: 16,
    border: "2px solid #E5E5E8",
  },
  icon: {
    width: 24,
    height: 24,
  },
  iconDisabled: {
    opacity: 0.2,
  },
  total: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: 30,
    marginBottom: 30,
    "& span": {
      fontSize: 22,
      fontWeight: "bold",
    },
  },
  addToCart: {
    width: "100% !important",
  },
  descContainer: {
    fontWeight: "bold",
    color: "#000",
    cursor: "pointer",
    padding: 15,
    borderRadius: 8,
    border: "1px solid rgb(131, 131, 131)",
    marginBottom: 15,
    width: 305,
  },
  allergens: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    cursor: "pointer",
    padding: 15,
    borderRadius: 8,
    border: "1px solid rgb(131, 131, 131)",
    marginBottom: 15,
    width: 305,
  },
  row: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
  },
  allergensLabel: {},
  allergensContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 10,
    maxWidth: 100,
  },
  title: {
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 5,
  },
  moreInfo: {
    fontSize: 14,
    marginBottom: 5,
    color: "rgb(131, 131, 131)",
  },
  moreInfoText: {
    fontSize: 11.5,
    marginBottom: 5,
    textAlign: "center",
    fontWeight: "bold",
  },
}));

export default useStyles;
